'use client';
import CaretLeft from '@/app/_components/ui/icons/CaretLeft.svg';
import React, { useEffect, useRef, useState } from 'react';
import UrlPlayer from '../share/videoPlayer/UrlPlayer';
import IframePlayer from '../share/videoPlayer/IframePlayer';
import UploadPlayer from '../share/videoPlayer/UploadPlayer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';

function SpVideo({ videos }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (videos.data.length > 3) {
      const swiperInstance = swiperRef.current.swiper;

      prevRef.current.addEventListener('click', () => {
        swiperInstance?.slidePrev();
      });

      nextRef.current.addEventListener('click', () => {
        swiperInstance?.slideNext();
      });
    }
  }, []);

  return (
    <>
      {videos.data.length > 0 && (
        <>
          <div
            className="spVideos mt-3 md:mt-8 p-0 md:p-8 bg-white"
            id="spVideos"
          >
            <div className="flex md:pb-6 md:pt-0 md:px-0 p-4 justify-between border-b border-light-gray-300 md:border-none">
              <div className="spNavTitle font-bold">ویدیو ها</div>
            </div>
            {/* Content */}
            <div className="flex justify-start items-center gap-5 p-4 md:p-0 w-full relative">
              <Swiper
                ref={swiperRef}
                slidesPerView={'auto'}
                spaceBetween={18}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                style={{ width: '100%' }}
              >
                <Swiper>
                  {videos?.data.map((video, index) => (
                    <SwiperSlide key={index} style={{ width: 'auto' }}>
                      <div className="videoPlayerWrap mb-12 w-[360px] mx-auto">
                        {
                          videos.type === 'url' &&
                          video?.url?.includes('frame') ? (
                            <IframePlayer video={video} />
                          ) : videos.type === 'url' ? (
                            <UrlPlayer key={index} video={video} />
                          ) : videos.type === 'upload' ? (
                            <UploadPlayer key={index} video={video} />
                          ) : videos.type === 'iframe' ? (
                            <IframePlayer key={index} video={video} />
                          ) : null // Handle other cases if needed
                        }
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Swiper>
              {/* Custom Previous Arrow Icon */}
              <div
                ref={prevRef}
                className="bg-white px-3 py-2 rounded-md shadow-sm cursor-pointer border-[1px] border-light-gray-200 z-10 absolute xs:-right-1 md:-right-5 cursor-pointer"
              >
                <CaretLeft className="rotate-180" />
              </div>
              {/* Custom Next Arrow Icon */}
              <div
                ref={nextRef}
                className="bg-white px-3 py-2 rounded-md shadow-sm cursor-pointer border-[1px] border-light-gray-200 z-10 absolute xs:-left-1 md:-left-5 cursor-pointer"
              >
                <CaretLeft />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default SpVideo;
